import React, {Component} from "react";
import {InstitutionService} from "../../../../service/maintenance/institution/InstitutionService";
import Contact from "./ContactView";
import {MAINTENANCE_INSTITUTIONS_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {REG_EXP_EMAIL, REG_EXP_TEL_NUMBERS} from "../../../../utils/constants/Constants"
import {Growl} from "primereact/growl";
import {deleteNonNumericPint} from "../../../../utils/formatters/Accent";

export default class ContactContainer extends Component {
    constructor(props) {
        super(props);

        this.institutionService = new InstitutionService();

        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.pushDataContact = this.pushDataContact.bind(this);
        this.saveDialogContact = this.saveDialogContact.bind(this);
        this.getErrors = this.getErrors.bind(this);

        this.state = {
            isLoading: false,
            returnPath: this.props.location.state.returnPath,
            institution: this.props.location.state.institution,
            contactList: this.props.location.state.contactList,
            signList: this.props.location.state.signList,
            actionScreen: this.props.location.state.actionScreen,
            roleType: this.props.location.state.roleType,
            contactType: this.props.location.state.contactType,
            actionContact: this.props.location.state.contactData.contactoOperativo ? "Editar" : "Agregar",
            contactData: this.props.location.state.contactData,
            dialogContact: {
                catContactType: this.props.location.state.contactData.contactoOperativo ?
                    {
                    IdTipoMedioComunica : this.props.location.state.contactData.idTipoMedioComunica,
                    DescrTipoMedioComunica : this.props.location.state.contactData.tipoMedioComunica
                    } : {},
                catRoleType: this.props.location.state.contactData.contactoOperativo ?
                    {
                    IdRolContacto: this.props.location.state.contactData.idRolContacto,
                    DescripcionRolContacto: this.props.location.state.contactData.rolContacto
                    } : {},
                contactDescription: this.props.location.state.contactData.contactoOperativo ?
                    this.props.location.state.contactData.decripcionMedioComunica : '',
                operativeContact: this.props.location.state.contactData.contactoOperativo ?
                    this.props.location.state.contactData.contactoOperativo : '',
            },
        }
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: this.state.returnPath,
            state: {
                returnPath: MAINTENANCE_INSTITUTIONS_ROUTE,
                activeIndex: 1,
                institution: this.state.institution,
                contactList: this.state.contactList,
                institutionId: this.state.institution.catInstitution.IdInstFinan,
                signList: this.state.signList,
            }
        });
    }

    saveDialogContact(event) {
        const {name, value} = event.target;
        let contact = this.state.dialogContact;
        if (name === 'contactDescription'){
            contact[name] = this.state.dialogContact.catContactType ?
                this.state.dialogContact.catContactType.IdTipoMedioComunica === 9 ?
                value : deleteNonNumericPint(value) : deleteNonNumericPint(value);
        }else{
            contact[name] = value;
        }
        this.setState({dialogContact: contact,})
    }

    getErrors() {
        let dialogContactAux = this.state.dialogContact;
        let msg = '';
        if (!dialogContactAux.catContactType || !dialogContactAux.catContactType['IdTipoMedioComunica']) {
            msg = 'Llenar los campos requeridos correctamente'
        } else if ((dialogContactAux.catContactType['IdTipoMedioComunica'] !== 9) &&
            (dialogContactAux.contactDescription === '' ||
                !REG_EXP_TEL_NUMBERS.test(dialogContactAux.contactDescription))) {
            msg = "Proporcione solo números para el campo descripción con el formato: \"1234567890\"";
        } else if ((dialogContactAux.catContactType['IdTipoMedioComunica'] === 9) &&
            (!REG_EXP_EMAIL.test(dialogContactAux.contactDescription) || (dialogContactAux.contactDescription === ''))) {
            msg = "Proporcione el siguiente formato en campo de descripción para E-mail: \"usuario@ejemplo.com\"";
        } else if (!dialogContactAux.catRoleType || !dialogContactAux.catRoleType['IdRolContacto']) {
            msg = 'Llenar los campos requeridos correctamente'
        }
        return msg;
    }

    async pushDataContact() {
        let errorMsg = this.getErrors();
        if (errorMsg !== '') {
            this.growl.show({severity: 'error', summary: 'Error.', detail: errorMsg});
        } else {
            let newContact = {
                idTipoMedioComunica: this.state.dialogContact.catContactType.IdTipoMedioComunica,
                tipoMedioComunica: this.state.dialogContact.catContactType.DescrTipoMedioComunica,
                decripcionMedioComunica: this.state.dialogContact.contactDescription,
                idRolContacto: this.state.dialogContact.catRoleType.IdRolContacto,
                rolContacto: this.state.dialogContact.catRoleType.DescripcionRolContacto,
                contactoOperativo: this.state.dialogContact.operativeContact,
                seleccionContactoOperativo: 1
            };
            let contactListAux = this.state.contactList;
            contactListAux.push(newContact);
            let contactListAux1 = await contactListAux.filter((val, i) =>
                val !== this.state.contactData);
            this.setState({contactList: contactListAux1});
            this.handleReturnButton();
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <Contact
                messagesGrowl={messagesGrowl}
                isLoading={this.state.isLoading}
                actionScreen={this.state.actionScreen}
                handleReturnButton={this.handleReturnButton}
                dialogContact={this.state.dialogContact}
                roleType={this.state.roleType}
                contactType={this.state.contactType}
                actionContact={this.state.actionContact}
                pushDataContact={this.pushDataContact}
                saveDialogContact={this.saveDialogContact}
            />)
    }
}